import { Fragment } from "react";

const ITEMS = ["Launch your business today", "Full admin control", "No monthly fees", "Free hosting & domain", "24/7 live support", "Keep what you earn"];

export const Marquee = () => (
  <section className="relative overflow-hidden border-y border-blue-700 bg-blue-600 py-8" data-testid="editorial-marquee" aria-label="Highlights">
    <div className="animate-marquee flex w-max items-center">
      {[0, 1].map((k) => (
        <div key={k} className="flex items-center" aria-hidden={k === 1}>
          {ITEMS.map((t, i) => (
            <Fragment key={t}>
              <span className={`font-display whitespace-nowrap px-8 text-3xl font-extrabold uppercase tracking-tight sm:text-5xl ${i % 2 ? "text-[#FACC15]" : "text-white"}`}>{t}</span>
              <svg viewBox="0 0 24 24" className="h-7 w-7 shrink-0 text-cyan-200 sm:h-9 sm:w-9"><path fill="currentColor" d="M12 0l2.6 9.4L24 12l-9.4 2.6L12 24l-2.6-9.4L0 12l9.4-2.6z" /></svg>
            </Fragment>
          ))}
        </div>
      ))}
    </div>
  </section>
);
